/**
 *
 * DropdownMenu
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import ClassNames from 'classnames';
function DropdownMenu(props) {
  const styles = () => ({
    root: {
      boxShadow: 'none !important',
      borderRadius: 0,
      border: '1px solid #E9ECED',
      textAlign: 'center',
      width: props.width ? `${props.width}px` : 'auto',
      position: 'relative',
      backgroundColor: props.background ? props.background : '#fff',
      zIndex: 9999,
    },
    centeredContent: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    },
    noBorder: {
      border: 'none',
    },
  });

  const { centered, children, borderColor } = props;

  /* eslint-disable */
   const div = props => (
     <Paper
       className={ClassNames(
         props.classes.root,
         centered && props.classes.centeredContent,
         borderColor === 'transparent' && props.classes.noBorder,
       )}
     >
       {children}
     </Paper>
   );
   const Styled = withStyles(styles)(div);
   return <Styled>{children}</Styled>;
 }
 
 DropdownMenu.propTypes = {
   children: PropTypes.node,
   height: PropTypes.number,
   width: PropTypes.number,
   background: PropTypes.string,
   borderColor: PropTypes.string,
   padding: PropTypes.number,
   centered: PropTypes.bool,
 };
 
 DropdownMenu.defaultProps = {
   borderColor: '#cccccc',
 };
 
 export default DropdownMenu;
 